import { render, staticRenderFns } from "./truckRequestDetails.vue?vue&type=template&id=1adb27f4&"
import script from "./truckRequestDetails.vue?vue&type=script&lang=js&"
export * from "./truckRequestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports